import { toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/constants/routes";
import {
  EstablishmentDetailResponse,
  getEstablishmentDetail,
  patchEstablishmentType,
} from "@/services/establishments.service";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { handlePermissionError } from "@/utils/permission-check";
import { Dispatch, SetStateAction } from "react";
import { NavigateFunction } from "react-router-dom";

interface FetchEstablishmentDetailHandlerProps {
  id: string;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setDetail: Dispatch<SetStateAction<EstablishmentDetailResponse | null>>;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
  silent?: boolean;
}

export const fetchEstablishmentDetailHandler = async ({
  id,
  setLoading,
  setDetail,
  navigate,
  fetchPermissions,
  silent = false,
}: FetchEstablishmentDetailHandlerProps) => {
  if (!silent) setLoading(true);
  try {
    const response = await getEstablishmentDetail(Number(id));
    setDetail(response ?? null);
  } catch (error) {
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.ESTABLISHMENTS_MAIN_PAGE,
    );
    if (!handled) {
      toaster.create({
        type: "error",
        title: getAxiosErrorMessage(error, "No se pudo obtener el detalle del establecimiento."),
      });
    }
    if (!silent) setDetail(null);
  } finally {
    if (!silent) setLoading(false);
  }
};

interface PatchEstablishmentTypeHandlerProps {
  idEstablecimiento: string;
  situacion: number;
  setLoading: Dispatch<SetStateAction<boolean>>;
  onSuccess: () => void;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const patchEstablishmentTypeHandler = async ({
  idEstablecimiento,
  situacion,
  setLoading,
  onSuccess,
  navigate,
  fetchPermissions,
}: PatchEstablishmentTypeHandlerProps) => {
  setLoading(true);
  try {
    await patchEstablishmentType({ idEstablecimiento, situacion });
    toaster.create({
      type: "success",
      title: "Tipo de Establecimiento modificado exitosamente.",
    });
    onSuccess();
  } catch (error) {
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.ESTABLISHMENTS_MAIN_PAGE,
    );
    if (!handled) {
      toaster.create({
        type: "error",
        title: getAxiosErrorMessage(error, "No se pudo actualizar el tipo de campo."),
      });
    }
  } finally {
    setLoading(false);
  }
};
